<script>
  // # # # # # # # # # # # # # # #
  //
  //  Ariel Vertical Logo
  //
  // # # # # # # # # # # # # # # #
</script>

<style lang="scss">
  svg {
    display: block;
    width: 40px;
  }
</style>

<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 43.7 185.5"
  style="enable-background:new 0 0 43.7 185.5;"
  xml:space="preserve">
  <style type="text/css">
    .st0 {
      clip-path: url(#SVGID_2_);
    }
  </style>
  <g>
    <defs>
      <rect id="SVGID_1_" x="2" y="1" width="39.8" height="183.1" />
    </defs>
    <clipPath id="SVGID_2_">
      <use xlink:href="#SVGID_1_" style="overflow:visible;" />
    </clipPath>
    <path
      class="st0"
      d="M34.9,65.9v11.6c0,4.6-0.6,8.8-5.3,8.8c-4.7,0-5.8-4.1-5.8-9.2V65.9H34.9z
      M2.6,57.2v8.7h15.3V75
      c0,8.5-1.6,10.2-9.2,10.5c-2.2,0.1-5,0.4-6.1,0.9v9.3c1.5-0.6,3.5-1,6.7-1.2c7.2-0.4,11.1-1.1,11.5-10h0.1
      c0.4,5.9,3.2,10.7,10,10.7c7.7,0,10.4-6.4,10.4-14.9V57.2H2.6z
      M2.6,110.6h38.7v-8.7H2.6V110.6z M41.3,148.3v-30.6H2.6v31.6h6.3
      v-22.9h10.6v21.1h6.3v-21.1h9.1v21.9H41.3z
      M2.6,154.2v29.9h6.3v-21.3h32.3v-8.7H2.6z" />
    <path
      class="st0"
      d="M2,8.9c0-2.6,0.6-4.6,1.7-6C4.8,1.7,6.4,1,8.4,1c5.5,0,13.9,5.1,20.9,12.8c8,8.6,12.5,18.4,12.5,26.8
      c0,2.4-0.7,3.9-2,4.5c-3,1.3-9.3-2.3-18.5-10.8c-0.1-0.1-0.1-0.3,0-0.5s0.3-0.1,0.5,0c8.8,8.1,15.1,11.9,17.8,10.7
      c1.1-0.5,1.6-1.8,1.6-3.9c0-8.2-4.5-17.8-12.3-26.3C21.8,6.8,13.6,1.7,8.4,1.7c-1.8,0-3.1,0.6-4.1,1.7c-1,1.2-1.6,3.1-1.6,5.5
      c0,7.5,5.3,16.1,9.8,22c2.7,3.5,5.7,6.9,8.4,9.7c8,3.7,15.9,8,17.7,9.1c2,1.3,3.2,2.7,3.1,3.6c0,0.4-0.3,0.7-0.6,0.9
      c-1.5,0.7-5.9-0.7-13.6-6.7c-1.9-1.5-4.4-3.7-7-6.4c-0.1-0.1-0.2-0.1-0.3-0.1C6.8,34.8,3.8,35,3.1,35.3c-0.1,0.1-0.2,0.2-0.2,0.4
      c0,2.5,13.5,12,22.6,17.8c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1c-0.1,0-5.8-3.7-11.4-7.7C2.2,38.1,2.2,36.3,2.2,35.7
      c0-0.4,0.2-0.8,0.6-1c1.8-1,9,1.7,16.5,5.1c-2.4-2.6-5-5.5-7.3-8.5C7.4,25.3,2,16.6,2,8.9
      M41.1,53.3c0-0.6-0.9-1.7-2.8-3
      c-2-1.3-8.7-4.9-15.9-8.3c2.1,2,4,3.7,5.6,5c7.9,6.2,11.9,7,12.9,6.6C41.1,53.5,41.1,53.4,41.1,53.3C41.1,53.3,41.1,53.3,41.1,53.3
      " />
  </g>
</svg>
